import { BoxVariant } from 'src/app/core/enums/box-variant.enum';
import { ConfigService } from './config.service';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(
    private configService: ConfigService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public activateTheme(colourTheme: string): Observable<void> {
    return new Observable((subscriber) => {
      if (!colourTheme) {
        subscriber.next();
        subscriber.complete();
        return;
      }

      const htmlClassList = this.document.documentElement.classList;

      this.configuredThemes$
        .pipe(take(1))
        .subscribe((configuredThemes: Array<any>) => {
          configuredThemes.forEach((theme: string) => {
            if (htmlClassList.contains(theme) && colourTheme !== theme) {
              htmlClassList.remove(theme);
            }
          });

          if (!htmlClassList.contains(colourTheme)) {
            htmlClassList.add(colourTheme);
          }

          subscriber.next();
          subscriber.complete();
        });
    });
  }

  public get configuredThemes$(): Observable<Array<String>> {
    return this.configService.state$.pipe(
      take(1),
      map((config: any) => config.availableThemes)
    );
  }

  public get preLoginBoxOptions(): Array<BoxVariant> {
    return [BoxVariant.AppBoxed, BoxVariant.ContentBoxed];
  }

  public get postLoginBoxOptions(): Array<BoxVariant> {
    return [BoxVariant.AppBoxed, BoxVariant.ContentBoxed, BoxVariant.UnBoxed];
  }
}
